import { render, staticRenderFns } from "./NewModel.vue?vue&type=template&id=8804c8c4&scoped=true&"
import script from "./NewModel.vue?vue&type=script&lang=js&"
export * from "./NewModel.vue?vue&type=script&lang=js&"
import style0 from "./NewModel.vue?vue&type=style&index=0&id=8804c8c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8804c8c4",
  null
  
)

export default component.exports